import {Box, Chip, CircularProgress, Typography} from '@mui/material';
import {Job, JobStatus} from '@cp/model';

interface JobDetailDialogStatusProps {
  job: Job;
}

const getStatusColor = (status: JobStatus) => {
  switch (status) {
    case JobStatus.COMPLETED:
      return 'success';
    case JobStatus.RUNNING:
      return 'primary';
    case JobStatus.FAILED:
      return 'error';
    case JobStatus.PENDING:
      return 'default';
    case JobStatus.CANCELLED:
      return 'default';
    default:
      return 'default';
  }
};

export default function JobDetailDialogStatus({job}: JobDetailDialogStatusProps) {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {job.title}
      </Typography>
      {job.description && (
        <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
          {job.description}
        </Typography>
      )}
      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mb: 2}}>
        <Chip label={job.status} color={getStatusColor(job.status)} size="small" />
        {job.status === JobStatus.RUNNING && job.progress !== null && job.progress !== undefined && (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <CircularProgress size={20} variant="determinate" value={job.progress} />
            <Typography variant="body2">{job.progress}%</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
